import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Skeleton,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { getStore, updateStore } from "../../actions/store";
import { EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { formatDate } from "../../utils/Utils";

const EditStoreInfo = ({ currentUser, storeCurrency }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const countries = require("../../utils/countries.json");
  const currency = require("../../utils/currency.json");
  const store = useSelector((state) => state.store)?.store?.storeInfo;
  const shippingType = useSelector((state) => state.store)?.store?.shippingInfo;
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const { Option } = Select;

  useEffect(() => {
    setLoading(true);
    setLoadingButton(false);
    dispatch(getStore(currentUser.store));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      name: store?.name,
      _id: store?._id,
      country: store?.country,
      currency: store?.currency,
      shippingType: store?.value,
      paymentType: store?.paymentType,
      storeStatus: store?.storeStatus,
    });
  }, [store, storeCurrency]);

  const onFinish = (formData) => {
    setLoadingButton(true);
    dispatch(updateStore(currentUser?.store, formData, setLoadingButton));
  };

  return (
    <Dashboard title="View Store">
      <div className="p-4 shadow bg-white mt-2 mb-6 flex items-center justify-between">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/store">Store</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{store?.name}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Form
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        form={form}
      >
        <div className="md:grid md:grid-cols-3 md:gap-6 mb-4">
          <div className="mt-5 md:mt-0 md:col-span-2 px-4 py-5 sm:p-6 bg-white shadow">
            <Skeleton loading={loading}>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please input name!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Country" name="country">
                    <Select
                      style={{ width: "100%" }}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {countries?.length > 0
                        ? countries?.map((country) => (
                            <Option key={country?.code} value={country?.name}>
                              {country?.name}
                            </Option>
                          ))
                        : ""}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Currency" name="currency">
                    <Select
                      style={{ width: "100%" }}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {currency?.length > 0
                        ? currency?.map((c) => (
                            <Option key={c?.id} value={c?.id}>
                              {c?.name}
                            </Option>
                          ))
                        : ""}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Status" name="storeStatus">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Created At">
                    <Input disabled value={formatDate(store?.createdAt)} />
                  </Form.Item>
                </Col>
              </Row>
            </Skeleton>
          </div>
          <div className="md:col-span-1">
            <div className="bg-white shadow px-4 py-5 sm:p-6">
              <Skeleton loading={loading}>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item label="Store Id" name="_id">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Shipping Methods" name="shippingType">
                      {shippingType?.length > 0 ? (
                        shippingType?.map((ship) => (
                          <div
                            key={ship?._id}
                            className="py-2 px-3 border my-1 flex items-center justify-between"
                            style={{ backgroundColor: "#f5f5f5" }}
                          >
                            <div>
                              {ship?.name}
                              <br />
                              {ship?.description} (
                              {`${storeCurrency}   ${ship.value}`})
                            </div>
                            <div>
                              <a href={`/shipping/${ship?._id}`}>
                                <EditOutlined className="cursor-pointer" />
                              </a>
                            </div>
                          </div>
                        ))
                      ) : (
                        <>
                          No Methods available
                          <Link to="/shipping"> Add Now</Link>
                        </>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <div className="flex flex-wrap  justify-end gap-4">
                      <Button href="/dashboard">Cancel</Button>
                      <Form.Item shouldUpdate style={{ margin: 0 }}>
                        {() => (
                          <Button
                            type="primary"
                            htmlType="submit"
                            loading={loadingButton}
                          >
                            Update
                          </Button>
                        )}
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              </Skeleton>
            </div>
          </div>
        </div>
      </Form>
    </Dashboard>
  );
};

export default EditStoreInfo;
